import { Tooltip } from "antd";
import ChartCard from "./ChartCard";

export const getXPositionInArray = (index, total, spacing = 100) => {
  const isEven = total % 2 === 0;
  const middleIndex = isEven ? total / 2 - 0.5 : Math.floor(total / 2);
  return (index - middleIndex) * spacing;
};

const newEdge = (source, target) => {
  return {
    source,
    target,
    type: "smoothstep",
    id: `${source}->${target}`,
  };
};

const ADMIN_DEP_ID = "77580ca0-d85d-11ec-bd74-ed7d1f113010";

export const generateNodes = (
  array,
  fetchedSrc,
  isDarkMode,
  setOpen,
  onClick
) => {
  if (!array) return { nodes: [], edges: [] };

  const idx = array.findIndex((el) => el?.departmentId === ADMIN_DEP_ID);
  if (idx === -1) return { nodes: [], edges: [] };

  const adminDep = array[idx];
  const adminDepRoles = adminDep?.departmentRoles || [];
  const adminDepEmployees = (adminDepRoles || [])
    .map((el) => el.employees)
    .flat();

  const nodes = [];
  const edges = [];

  const adminNode = {
    id: adminDep?.departmentName,
    data: { label: (adminDep?.departmentName || "").toUpperCase() },
    position: { x: 0, y: 0 },
    draggable: false,
    className: "departmentNode" + (isDarkMode ? " dark" : ""),
  };

  nodes.push(adminNode);

  let adminEmployeesWrapperNodeWidth = 0;
  const adminEmployeeNodes = [];
  for (let [i, emp] of adminDepEmployees.entries()) {
    const src = fetchedSrc[emp?.googleDriveFileId];
    const employeeNode = {
      id: `${adminDep?.departmentName}-${i}`,
      data: { label: <ChartCard src={src} employee={emp} setOpen={setOpen} /> },
      position: {
        x: adminDepEmployees.length === 1 ? 10 : i * 190 + 20,
        y: 10,
      },
      draggable: false,
      className: "employeeNode" + (isDarkMode ? " dark" : ""),
      parentId: adminDep?.departmentName + "-wrapper",
    };
    adminEmployeesWrapperNodeWidth += 190 + 10;
    adminEmployeeNodes.push(employeeNode);
  }

  const xPos = (190 - adminEmployeesWrapperNodeWidth) / 2;
  const adminEmployeesWrapperNode = {
    id: adminDep?.departmentName + "-wrapper",
    position: { x: xPos, y: 50 },
    className: "employeesWrapperNode" + (isDarkMode ? " dark" : ""),
    style: { width: adminEmployeesWrapperNodeWidth, height: 70 },
    draggable: false,
  };

  nodes.push(adminEmployeesWrapperNode);
  nodes.push(...adminEmployeeNodes);
  edges.push(newEdge(adminNode.id, adminEmployeesWrapperNode.id));

  const depsToLoop = array.filter((el) => el?.departmentId !== ADMIN_DEP_ID);

  if (!depsToLoop.length) return { nodes: [], edges: [] };

  const departmentsNodes = [];
  const departmentsEdges = [];

  let allDepartmentsNodeWrapper = {
    id: "allDepartmentsWrapper",
    position: { x: 0, y: 170 },
    style: { display: "none" },
    draggable: false,
  };

  let totalWidthOfAllDepartments = 0;

  //region DEPARTMENTS LOOPING
  for (let dep of depsToLoop) {
    const depRoles = dep?.departmentRoles || [];

    let depWrapperNode = {
      id: dep?.departmentName + "-wrapper",
      position: {
        x: totalWidthOfAllDepartments + 10,
        y: 20,
      },
      className: "departmentWrapperNode" + (isDarkMode ? " dark" : ""),
      parentId: allDepartmentsNodeWrapper.id,
      draggable: false,
    };
    let departmentNode = {
      id: dep.departmentName,
      data: { label: dep?.departmentName },
      position: { y: 10 },
      className: "departmentNode" + (isDarkMode ? " dark" : ""),
      parentId: depWrapperNode.id,
      draggable: false,
    };

    const { supervisors = [] } = dep;
    let supervisorWrapperNode = {
      id: `${dep?.departmentName}-supervisors-wrapper`,
      // 50 departmentNode height + 40 padding
      position: { y: departmentNode.position.y + 50 + 40 },
      style: { width: supervisors.length * 190 + 10, height: 70 },
      draggable: false,
      className: "employeesWrapperNode" + (isDarkMode ? " dark" : ""),
      parentId: departmentNode.id,
    };
    const supervisorsNodes = [];
    for (let [i, supervisor] of supervisors.entries()) {
      const src = fetchedSrc[supervisor?.googleDriveFileId];
      const fullName = `${supervisor?.employeeFirstName} ${supervisor?.employeeLastName}`;

      supervisorsNodes.push({
        id: `${dep?.departmentName}-${fullName}`,
        data: {
          label: (
            <ChartCard src={src} employee={supervisor} setOpen={setOpen} />
          ),
        },
        position: { x: i * 190 + 10, y: 10 },
        draggable: false,
        className: "employeeNode" + (isDarkMode ? " dark" : ""),
        parentId: supervisorWrapperNode.id,
      });
    }
    let allDepartmentRolesWidth = 0;

    //region ROLES LOOPING
    for (let [i, role] of depRoles.entries()) {
      const roleEmployees = role?.employees || [];

      const makeGrid = roleEmployees.length > 10;
      const halfEmployees = Math.ceil((roleEmployees.length || 1) / 2);
      const xPos = makeGrid
        ? (i === 0 ? 0 : allDepartmentRolesWidth) + 10 + (390 - 190) / 2
        : (i === 0 ? 0 : allDepartmentRolesWidth) + 15;
      let roleNode = {
        id: `${dep.departmentName}-${role?.name}`,
        data: {
          label: (
            <Tooltip placement="top" title="Rendit punonjësit">
              <span
                className="roleNodeLabel"
                onClick={() => onClick(dep, role)}
              >
                {role?.name} {"(" + (roleEmployees.length || 0) + ")"}
              </span>
            </Tooltip>
          ),
        },
        position: {
          x: xPos,
          // 80 supervisorWrapperNode height 50 padding
          y: supervisorWrapperNode.position.y + 80 + 50,
        },
        className: "roleNode" + (isDarkMode ? " dark" : ""),
        parentId: depWrapperNode.id,
      };

      const depEmployeeNodes = [];
      if (!roleEmployees.length) {
        depEmployeeNodes.push({
          id: `${dep.departmentName}-${role?.name}-empty`,
          data: { label: "Nuk ka punonjës" },
          position: { x: 0, y: 50 + 30 },
          draggable: false,
          parentId: roleNode.id,
          className: "employeeNode" + (isDarkMode ? " dark" : ""),
        });
      } else {
        //region EMPLOYEES LOOPING
        for (let [j, emp] of roleEmployees.entries()) {
          const src = fetchedSrc[emp?.googleDriveFileId];
          const xPos =
            (makeGrid ? (j >= halfEmployees ? 190 : -(390 / 2)) : 10) / 2;
          const yPos =
            (makeGrid && j >= halfEmployees ? j + 1 - halfEmployees : j + 1) *
              50 +
            20;
          const employeeNode = {
            id: `${dep.departmentName}-${role?.name}-${j}`,
            data: {
              label: <ChartCard src={src} employee={emp} setOpen={setOpen} />,
            },
            position: { x: xPos, y: yPos },
            draggable: false,
            parentId: roleNode.id,
            className: "employeeNode" + (isDarkMode ? " dark" : ""),
          };
          depEmployeeNodes.push(employeeNode);
        }
      }

      const wrapperXPos =
        getXPositionInArray(i, depRoles.length, 0) -
        (makeGrid ? (390 - 190) / 2 : 0);
      const roleWrapperHeight = makeGrid
        ? halfEmployees * 50
        : (roleEmployees.length || 1) * 50;

      const roleEmployeesWrapperNode = {
        id: `${dep.departmentName}-${role?.name}-wrapper`,
        // 50 roleNode height + 20 padding
        position: { x: wrapperXPos, y: 50 + 20 },
        className: "employeesWrapperNode" + (isDarkMode ? " dark" : ""),
        parentId: roleNode.id,
        draggable: false,
        //390 = 190 * 2 + 10 padding
        style: { width: makeGrid ? 390 : 190, height: roleWrapperHeight },
      };

      const depWrapperNodeHeight = () => {
        //margin top + depNode height + padding + supervisorWrapperNode height + padding + roleNode height + padding
        const idx = depRoles.findIndex(
          (el) =>
            el?.employees.length ===
            Math.max(...depRoles.map((el) => el?.employees.length))
        );
        const employeesLength =
          depRoles[idx].employees.length > 10
            ? Math.ceil(depRoles[idx].employees.length / 2)
            : depRoles[idx].employees.length;
        const employeesHeight = employeesLength * 50;

        return 10 + 30 + 40 + 50 + 50 + 30 + 40 + employeesHeight + 80;
      };
      const totalDepartmentWidth = (makeGrid ? 380 : 190) + 10;
      allDepartmentRolesWidth += totalDepartmentWidth + 20;
      const supervisorsWidth = supervisors.length * 200 + 10;
      if (allDepartmentRolesWidth < supervisorsWidth) {
        roleNode.position.x =
          (supervisorsWidth - allDepartmentRolesWidth + 30) / 2;
        allDepartmentRolesWidth = supervisorsWidth;
      }

      depWrapperNode.style = {
        width: allDepartmentRolesWidth,
        height: depWrapperNodeHeight(),
      };
      departmentNode.position.x = (allDepartmentRolesWidth - 190) / 2;
      const sL = supervisors.length;
      supervisorWrapperNode.position.x =
        (190 - (200 * sL + (sL > 1 ? -10 : 0))) / 2;

      departmentsNodes.push(depWrapperNode);
      departmentsNodes.push(departmentNode);
      departmentsNodes.push(supervisorWrapperNode);
      departmentsNodes.push(...supervisorsNodes);
      departmentsNodes.push(roleNode);
      departmentsNodes.push(roleEmployeesWrapperNode);
      departmentsNodes.push(...depEmployeeNodes);

      departmentsEdges.push(
        newEdge(adminEmployeesWrapperNode.id, departmentNode.id)
      );
      departmentsEdges.push(
        newEdge(departmentNode.id, supervisorWrapperNode.id)
      );
      departmentsEdges.push(newEdge(supervisorWrapperNode.id, roleNode.id));
      departmentsEdges.push(newEdge(roleNode.id, roleEmployeesWrapperNode.id));
    }
    totalWidthOfAllDepartments += allDepartmentRolesWidth + 20;
  }

  allDepartmentsNodeWrapper.style.width = totalWidthOfAllDepartments;
  allDepartmentsNodeWrapper.position.x = (190 - totalWidthOfAllDepartments) / 2;

  nodes.push(allDepartmentsNodeWrapper);

  nodes.push(...departmentsNodes);
  edges.push(...departmentsEdges);

  return { nodes, edges };
};

export const sortArrayByIds = (arr, ids, key) => {
  if (!Array.isArray(arr) || !arr.length) return arr;
  if (!ids || !ids.length) return arr;

  const unsorted = [];
  const sorted = [];
  for (const empl of arr) {
    const idx = ids.findIndex((id) => id === empl?.[key]);
    if (idx !== -1) sorted[idx] = empl;
    else unsorted.push(empl);
  }
  sorted.push(...unsorted);
  return sorted;
};

const isObj = (e) => typeof e === "object" && e !== null && !Array.isArray(e);

export const filterWithNestedFilters = (arr, filterObj, preFilter) => {
  if (!Array.isArray(arr) || !arr.length) return arr;
  if (!filterObj || !Object.keys(filterObj).length) return arr;

  return arr
    .map((el) => {
      if (!!preFilter && typeof preFilter === "function") {
        const preFilterResult = preFilter(el);
        if (preFilterResult) return null;
      }

      let matches = true;
      let newEl = { ...el };

      for (const [key, value] of Object.entries(filterObj)) {
        if (key === "employeeTeam" && value === "Të gjithë") {
          continue;
        }
        const elValue = el?.[key];

        if (isObj(value)) {
          if (Array.isArray(elValue)) {
            // Filter inner array using nested filter
            const filteredArray = filterWithNestedFilters(elValue, value);
            if (filteredArray.length) {
              newEl[key] = filteredArray;
            } else {
              matches = false;
              break;
            }
          } else if (isObj(elValue)) {
            const filtered = filterWithNestedFilters([elValue], value);
            if (filtered.length) {
              newEl[key] = filtered[0];
            } else {
              matches = false;
              break;
            }
          } else {
            matches = false;
            break;
          }
        } else if (value !== undefined && elValue !== value) {
          matches = false;
          break;
        }
      }

      return matches ? newEl : null;
    })
    .filter(Boolean);
};
